const DEFAULT_FLAGS = Object.freeze({
  engine2: true,
  developerTestLab: true,
  legacyV31: true,
  hiddenWorld: false,
  livingWorld2: false,
  storyMode: false,
  multiplayer: false,
  webGPU: false,
  advancedWater: false,
});

export class FeatureFlags {
  constructor(storage = window.localStorage) {
    this.storage = storage;
    this.flags = { ...DEFAULT_FLAGS, ...this.#load() };
  }

  get(name) {
    return Boolean(this.flags[name]);
  }

  set(name, enabled) {
    if (!(name in DEFAULT_FLAGS)) {
      throw new Error(`Unknown feature flag: ${name}`);
    }
    this.flags[name] = Boolean(enabled);
    this.storage.setItem('serpent.featureFlags', JSON.stringify(this.flags));
  }

  snapshot() {
    return { ...this.flags };
  }

  #load() {
    try {
      return JSON.parse(this.storage.getItem('serpent.featureFlags') || '{}');
    } catch {
      return {};
    }
  }
}

export { DEFAULT_FLAGS };
